import { CommonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';
import ToIntIfInt from '../../utils/ToIntIfInt';

const GetRouteCodeValueData = (routeCodeValue, state, setState) => {
  if (routeCodeValue && state.isObjLoading !== true && !state.message) {
    let newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      message: 'Loading...',
      routeCodeValue,
    };
    setState(newState);

    const url = `/RouteCode/CodeValue/${routeCodeValue}`;
    CommonHttpHelper(url, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          };
          objData.routeCodeDetail?.forEach(rcd => {
            newState[rcd.detailName] = ToIntIfInt(rcd.detailValue);
          });
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isObjLoading: false,
          message: message
        });
      });
  }
};

export default GetRouteCodeValueData;